import { Trans } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { getTestProps } from '../../lib/helpers';

interface ResultsPerPageLabelProps {
  /**
   * Index of first result
   */
  resultsIntervalFrom?: number;
  /**
   * Index of last result
   */
  resultsIntervalTo?: number;
  /**
   * Results total count
   */
  resultsTotalCount?: number;
  /**
   * Component wrapper additional classes
   */
  additionalClasses?: string;
  /**
   * Component test id
   */
  testId?: string;
}

const ResultsPerPageLabel = ({
  resultsIntervalFrom = 1,
  resultsIntervalTo = 1,
  resultsTotalCount = 1,
  additionalClasses = '',
  testId = '',
}: ResultsPerPageLabelProps) => {
  return (
    <div
      className={twMerge(
        'font-medium text-sm 2xl:text-base leading-none text-center py-3 select-none dark:text-slate-200',
        additionalClasses,
      )}
      {...getTestProps(testId, 'wrapper')}
    >
      <div {...getTestProps(testId, 'text')}>
        <Trans
          i18nKey="ResultsPerPageLabel.phrase"
          values={{
            resultsIntervalFrom: resultsIntervalFrom || 0,
            resultsIntervalTo: resultsIntervalTo || 0,
            resultsTotalCount: resultsTotalCount || 0,
          }}
          components={{
            4: <span className="font-bold" />,
          }}
        ></Trans>
      </div>
    </div>
  );
};

export default ResultsPerPageLabel;
